//React
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
//Components
//Styles
import 'swiper/css';
import 'swiper/css/pagination';
import '../../styles/static-pages.css';
//Import required modules
import { Pagination } from 'swiper/modules';

const SwiperReviews = ({ reviews }) => {

    const language = localStorage.getItem('language');

    return (
        <>
            <Swiper
                breakpoints={{
                    0: {           // desde 0px hasta 899px
                        slidesPerView: 1,
                    },
                    900: {         // desde 900px hasta arriba
                        slidesPerView: 2,
                    },
                    1200: {        // ejemplo, desde 1200px
                        slidesPerView: 3,
                    }
                }}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                className="mySwiper"
            >
                {reviews && reviews.map((review, index) => (
                    <SwiperSlide key={index} className='container-swiper-card'>
                        <div className='contain-swiper-card'>
                            <p>{review.description}</p>
                            <p className='swiper-card-title'>{review.name}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
}

export default SwiperReviews;